// extracted by mini-css-extract-plugin
module.exports =  {"info":"info__H5v1K","listingId":"listingId__bFsVP","listingName":"listingName__iRA-Y","col":"col__360aX","lastCol":"lastCol__HWNcx","listingAndNameCol":"listingAndNameCol__wfc43"};